const EmptyState = ({ icon: Icon, title, description }) => {
  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center py-5"
      style={{ color: "var(--text-tertiary)" }}
    >
      {Icon && <Icon style={{ fontSize: "48px", marginBottom: "12px" }} />}
      {title && (
        <p className="fw-semibold mb-1" style={{ fontSize: "16px", color: "var(--text-secondary)" }}>
          {title}
        </p>
      )}
      {description && (
        <p className="mb-0" style={{ fontSize: "14px" }}>
          {description}
        </p>
      )}
    </div>
  );
};

export default EmptyState;
